namespace RioERP.Masters {
    export interface DelhiveryApiDetailsForm {
        Token: Serenity.StringEditor;
        ShippingMode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        Address: Serenity.StringEditor;
        City: Serenity.StringEditor;
        Pincode: Serenity.StringEditor;
        Phone: Serenity.StringEditor;
    }

    export class DelhiveryApiDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.DelhiveryApiDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DelhiveryApiDetailsForm.init)  {
                DelhiveryApiDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(DelhiveryApiDetailsForm, [
                    'Token', w0,
                    'ShippingMode', w0,
                    'Name', w0,
                    'Address', w0,
                    'City', w0,
                    'Pincode', w0,
                    'Phone', w0
                ]);
            }
        }
    }
}
